/**
 * 验证码 API
 */

import apiClient from './client';

export interface SendCodeRequest {
  email: string;
  purpose?: 'register' | 'login' | 'reset_password';
}

export interface VerifyCodeRequest {
  email: string;
  code: string;
  purpose?: 'register' | 'login' | 'reset_password';
}

export interface SendCodeResponse {
  success: boolean;
  message: string;
  data: {
    expires_in: number;
    purpose: string;
  };
}

export interface VerifyCodeResponse {
  success: boolean;
  message: string;
  data: {
    verified: boolean;
    email: string;
  };
}

/**
 * 发送验证码
 */
export async function sendVerificationCode(data: SendCodeRequest): Promise<SendCodeResponse> {
  return apiClient.post('/verification/send', data);
}

/**
 * 验证验证码
 */
export async function verifyVerificationCode(data: VerifyCodeRequest): Promise<VerifyCodeResponse> {
  return apiClient.post('/verification/verify', data);
}
